/**
 * The public Orcaloops Terms of Service, served at `orcaloops.ai/terms`
 * (internally `/orca/terms`).
 *
 * Reachable with NO session — `orca-public-paths.ts` lists `/orca/terms` as a
 * public root, so the `/orca` layout guard returns before `requireAdmin`.
 * Google's OAuth review expects the terms alongside the privacy policy on the
 * authorized domain, so this page must never carry `robots: noindex` either.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

import orcaDocCss from "~/components/orca/orca-doc.css?url";
import { OrcaTermsPage } from "~/components/orca/OrcaTermsPage.tsx";
import { orcaloopsStylesheetLinks } from "~/lib/orcaloops-head.ts";

/**
 * Head meta and sheets for the terms of service (the v5 frame sheet, then the
 * reading-column sheet). Deliberately crawlable — no `robots`
 * directive.
 *
 * @since 1.0.0
 */
export const orcaTermsHead = () => ({
  meta: [
    { title: "Terms of Service — Orcaloops" },
    { name: "description", content: "The terms governing your use of Orcaloops." },
  ],
  links: [...orcaloopsStylesheetLinks, { rel: "stylesheet", href: orcaDocCss }],
});

export const Route = createFileRoute("/orca/terms")({
  head: orcaTermsHead,
  component: OrcaTermsPage,
});
